import {Button, Pagination, Table, TextInput} from "omoplay";
import {useEffect, useState} from "react";
import {getTargetCustomers, testSend, validateContentReason} from "../../api/message/volatility-message.api";
import {getUsers, getUsersAll} from "../../api/user/user.api";
import moment from "moment/moment";
import {MESSAGE_TARGET_FILTER} from "../../constants/menus";
import {getProjectList} from "../../api/project/project.api";
import {getRegionTree} from "../../api/region/region.api";

const TargetMessageForm = ({id, isTest, isBrandMsg, selectUserIds, messageData, automateId, onSelectedUserIds, onSendMessage}) => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [users, setUsers] = useState({ kakaoUsers: [] });
    const [isSending, setSending] = useState(false)
    const [selectUsers, setSelectUsers] = useState([])
    const [innerSelectUserIds, setInnerSelectUserIds] = useState(selectUserIds ?? [])

    const requestTestSend = () => {
        // 테스트 발송도 실제 카카오 발송이라 필수 항목이 비면 발송 서버가 요청을 거절한다
        // (2026-07-29 인시던트: 빈 항목 → 발송 서버 400 → redirect 500 → 화면 튕김).
        // 발송을 시도하기 전에 같은 규칙으로 검사해 사유를 알려준다.
        const reason = validateContentReason(messageData)
        if (reason) {
            alert(`필수 항목을 모두 입력해야 테스트 발송할 수 있습니다.\n\n· ${reason}\n\n'콘텐츠 작성하기' 단계로 돌아가 내용을 완성한 뒤 다시 시도해 주세요.`)
            return
        }

        setSending(true)
        testSend(innerSelectUserIds, isBrandMsg, messageData, automateId)
            .then((res) => {
                // 응답을 확인하지 않고 성공 안내를 띄우면 발송 실패인데 "발송 되었습니다"가 뜬다.
                // (백엔드 검증 400 은 fetch.js 가 사유를 alert 하고 여기까지 오지 않는다.)
                if (res?.code !== 2000) {
                    setSending(false)
                    alert("테스트 발송에 실패했습니다. 메시지 내용을 확인한 뒤 다시 시도해 주세요.")
                    return
                }
                alert("발송 되었습니다.")
                onSendMessage()
            })
    }

    const headers = [
        { name: "이름", align: "center", width: "120px" },
        { name: "성별", align: "center", width: "80px" },
        { name: "전화번호", width: "160px" },
        { name: "회원가입" },
        { name: "", width: "120px" }
    ];

    const displayGenderText = (gender) => {
        if (gender === "male") {
            return "남성";
        } else if (gender === "female") {
            return "여성";
        } else {
            return gender;
        }
    };

    useEffect(() => {
        getProjectList().then(({data}) => {
            const projectFilterIndex = MESSAGE_TARGET_FILTER.findIndex(
                (item) => item.value === "project"
            );
            // MESSAGE_TARGET_FILTER 에 'project' 항목이 없으면 findIndex 가 -1 → 크래시 방지 가드
            if (projectFilterIndex !== -1) {
                MESSAGE_TARGET_FILTER[projectFilterIndex].data = data.map((project) => {
                    return { value: project.id, label: project.name };
                });
            }
        })
        // 주소(배송지) 필터 지역 트리를 API로 채움(하드코딩 제거).
        getRegionTree().then(({data}) => {
            const addressFilterIndex = MESSAGE_TARGET_FILTER.findIndex(
                (item) => item.value === "address"
            );
            if (addressFilterIndex !== -1) {
                MESSAGE_TARGET_FILTER[addressFilterIndex].data = data ?? [];
            }
        })
        if (id != null && innerSelectUserIds.length === 0) {
            getTargetCustomers(id).then(({data}) => {
                onSelectedUserIds(data)
            })
        }
    }, []);

    useEffect(() => {
        getUsers(search, null, null, true, page - 1, 4, "createdAt,desc").then((res) => {
            setUsers(res.data)
        })
    }, [page, search]);

    useEffect(() => {
        getUsersAll(innerSelectUserIds).then(({data}) => {
            setSelectUsers(data.map(user => {
                return [
                    <div className="text-center">{user.name}</div>,
                    <div className="text-center">{displayGenderText(user.gender)}</div>,
                    user.phoneNumber,
                    <div className="flex-col">
                        <div>
                            {moment(user.createdAt)
                                .add(9, "hours")
                                .format("YYYY.MM.DD HH:mm")}
                        </div>
                    </div>,
                    <div>
                        <Button variants="danger" value="삭제" onClick={() => {
                            onSelectedUserIds(innerSelectUserIds.filter((value) => value !== user.id))
                            setInnerSelectUserIds(innerSelectUserIds.filter((value) => value !== user.id))
                        }} />
                    </div>
                ]
            }))
        })
    }, [innerSelectUserIds]);

    const tableData = users.kakaoUsers.map(user => {
        return [
            <div className="text-center">{user.name}</div>,
            <div className="text-center">{displayGenderText(user.gender)}</div>,
            user.phoneNumber,
            <div className="flex-col">
                <div>
                    {moment(user.createdAt)
                        .add(9, "hours")
                        .format("YYYY.MM.DD HH:mm")}
                </div>
            </div>,
            <div>
                <Button variants="outlined" value="선택" onClick={() => {
                    onSelectedUserIds([user.id, ...innerSelectUserIds])
                    setInnerSelectUserIds([user.id, ...innerSelectUserIds])
                }} />
            </div>
        ]
    })

    return (
        <div>
            <div>
                <div className="font-semibold" style={{marginBottom: "16px", marginTop: "16px"}}>전화번호 검색하기</div>
                <div style={{width: "300px", marginBottom: "16px"}}>
                    <TextInput showIcon={true} placeholder="전화번호 검색"
                               onKeyDown={(e) => {
                                   if (e.keyCode === 13) {
                                       setPage(1)
                                       setSearch(e.currentTarget.value)
                                   }
                               }} />
                </div>
                <Table headers={headers} data={tableData} />
                <div className="flex justify-center" style={{marginTop: "24px"}}>
                    <Pagination pageSize={4} totalCount={users.totalCount} currentPage={page} onPaging={(page) => setPage(page)} />
                </div>
            </div>
            <div>
                <div className="font-semibold" style={{marginBottom: "16px", marginTop: "16px"}}>발송 대상</div>
                <div>
                    <Table headers={headers} data={selectUsers} pagination={{
                        rowSize: 4,
                        totalSize: selectUsers.length
                    }} />
                </div>
            </div>
            {
                isTest && (
                    <>
                        <div className="flex justify-center">
                            <div className="text-center">
                                <div>* 선택된 대상이 메시지 차단 등으로 발송이 불가할 수 있습니다.</div>
                                <div className="text-red-500">* 하나의 휴대폰 번호로 1시간에 최대 3번까지 발송할 수 있습니다.</div>
                            </div>
                        </div>
                        <div className="flex-center-all">
                            <div className="flex-center-all" style={{marginBottom: "16px", marginTop: "8px", width: "300px"}}>
                                <Button variants="primary" value="테스트 발송하기" onClick={() => {
                                    requestTestSend()
                                }} disabled={isSending || innerSelectUserIds.length === 0}
                                />
                            </div>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default TargetMessageForm